import { toast } from "sonner";

export const PURPOSES = ["organic", "paid_ads", "outreach", "qr_offline"];
export const STATUSES = ["active", "deactivated"];

export const Field = ({ label, hint, children }) => (
  <label className="flex flex-col gap-1.5">
    <span className="font-body text-xs uppercase tracking-[0.14em] text-ink-soft">{label}</span>
    {children}
    {hint && <span className="font-body text-xs text-ink-soft/70">{hint}</span>}
  </label>
);

export const TextInput = (props) => (
  <input
    {...props}
    className={`bg-paper border border-ink/15 px-3 py-2 font-body text-ink focus:outline-none focus:border-terracotta transition-colors ${props.className || ""}`}
  />
);

export const TextArea = (props) => (
  <textarea
    {...props}
    className={`bg-paper border border-ink/15 px-3 py-2 font-body text-ink focus:outline-none focus:border-terracotta transition-colors resize-y ${props.className || ""}`}
  />
);

export const Select = ({ value, onChange, options, includeEmpty, ...rest }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    {...rest}
    className="bg-paper border border-ink/15 px-3 py-2 font-body text-ink focus:outline-none focus:border-terracotta transition-colors"
  >
    {includeEmpty && <option value="">Any</option>}
    {options.map((o) => (
      <option key={o} value={o}>{o}</option>
    ))}
  </select>
);

export function copyToClipboard(text, label) {
  navigator.clipboard.writeText(text).then(
    () => toast.success(`${label} copied`),
    () => toast.error("Could not copy — copy manually"),
  );
}
